export type FerramentaManualAnimada = 'hooligan' | 'puncaoVidro'

export interface PoseFerramentaManual {
  rotacaoAlavanca: number
  deslocamentoGolpe: number
  tracaoMola?: number
  giroTorcao?: number
  deslocamentoInsercao?: number
}

const limitar = (valor: number) => Math.max(0, Math.min(1, valor))

/** Movimento didático determinístico; não representa força nem tempo reais. */
export function poseFerramentaManual(
  ferramenta: FerramentaManualAnimada,
  progresso: number,
): PoseFerramentaManual {
  const p = limitar(progresso)
  if (ferramenta === 'hooligan') {
    // Fase 1 (0 a 0.35): a cunha entra e encaixa na fresta da porta próximo à fechadura
    const pEncaixe = Math.min(1, p / 0.35)
    const deslocamentoInsercao = pEncaixe * 0.045
    // Fase 2 (0.35 a 1.0): a ferramenta gira 90° em torno do seu eixo e alavanca para abrir o gap
    const pGiro = p <= 0.35 ? 0 : (p - 0.35) / 0.65
    const giroTorcao = pGiro * (Math.PI / 2) // 90° de torção da cunha
    const rotacaoAlavanca = pGiro * 0.18 // alavancagem para criar o vão
    return {
      rotacaoAlavanca,
      deslocamentoGolpe: 0,
      giroTorcao,
      deslocamentoInsercao,
    }
  }
  const tracaoMola = p < 0.72 ? (p / 0.72) * 0.055 : Math.max(0, (1 - (p - 0.72) / 0.28) * 0.055)
  return { rotacaoAlavanca: 0, deslocamentoGolpe: 0, tracaoMola }
}

